import { InjectionToken } from '@angular/core';

export interface SharedCoreConfig {
  apiUrl: string;
  authAuthority: string;
  authApiScopes: string[];
}

export const SHARED_CORE_CONFIG = new InjectionToken<SharedCoreConfig>('SHARED_CORE_CONFIG');
